export const projectListColumns = [
  { field: 'client', headerName: 'Cliente', lookUp: 'client' },
  { field: 'name', headerName: 'Proyecto' },
  { field: 'lead', headerName: 'Lider', lookUp: 'lead.name' },
  { field: 'type', headerName: 'Tipo' },
  { field: 'actions', headerName: 'Acciones' },
];
